// extracted by mini-css-extract-plugin
export default {"container":"project_container__bWWr4","project1":"project_project1__8ckTR","link":"project_link__3LZoo"};